module.exports = __webpack_public_path__ + "static/media/bam.8af215dc.png";